import { createSelector } from 'reselect';
const getVehicleInfoDataSource = (state) => state.domain.vehicleInfo.vehicleInfoData || undefined;
export const getVehicleInfoData = createSelector([getVehicleInfoDataSource], result => result);
//# sourceMappingURL=getVehicleInfoData.js.map